<template>
  <div>
    <el-dialog
      :title="title"
      :visible="localVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form :rules="rules" ref="form" size="small" :model="formData" label-width="100px">
         <el-form-item label="Appid" prop="appid">
          <el-input
            v-model="form.appid"
            clearable
            placeholder="请输入appid"
          ></el-input>
         </el-form-item>
        <el-form-item label="接口路径" prop="api_path">
          <el-input
            v-model="form.api_path"
            clearable
            placeholder="请输入接口路径"
          ></el-input>
        </el-form-item>

        <el-form-item label="私钥" prop="private_key">
          <el-input
            :readonly="true"
            v-model="form.private_key"

            placeholder="请输入私钥"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="公钥">
          <el-input
            :readonly="true"
            v-model="form.public_key"
            placeholder="请输入公钥"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">

        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>

        <el-button type="warning" size="small" @click="createRSA">生成RSA</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  // import NodeRSA from 'node-rsa';
  export default {
    name:'ePOS',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data(){
      return {
        rules: {
          appid: [
            { required: true, message: "请输入appid", trigger: "blur" },

          ],
          api_path: [
            { required: true, message: "请输入路径", trigger: "blur" },

          ],
          private_key: [
            { required: true, message: "请输入私钥", trigger: "blur" },

          ]
        },
        form:{
          appid:'',
          api_path:'',
          private_key:'',
          public_key:''

        },
        localVisible:false,
        curShop:'',
        employee_id:'',
        name_cn:'',
        keywords:'',
        fileList:[],
        mList:[],
        pageNum:1,
        pageSize:10
      }
    },
    mounted() {


     // this.getList();
    },
    methods:{
      createRSA(){
      //  const key = new NodeRSA({ b: 2048 });
        // const publicKey = key.exportKey('public');
        // const privateKey = key.exportKey('private');
        // this.formData.public_key=publicKey;
        // this.formData.private_key=privateKey;
      },
      // 关闭
      handleClose() {
        this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 前置提交
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
          let _this=this;
          let param={
            appid:this.formData.appid,
            private_key:this.formData.private_key,
            public_key:this.formData.public_key,
            id:this.formData.id,
            api_path:this.formData.api_path,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }

          this.$axios.shopSave(param).then(res=>{
            if(res.code == 200){
              this.$message.success("修改成功");
              _this.handleClose();
            }else if(res.code == 606){
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })

      },

      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      }
    },
    // 监听
    watch: {
      visible(val) {
        this.localVisible=val;
        console.log('999999---888--ooppppppp')
        if (val) {

          this.form.appid=this.formData.appid;
          this.form.api_path=this.formData.api_path;
          this.form.private_key=this.formData.private_key;
          this.form.public_key=this.formData.public_key;

          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
